import React from "react";
import Box from "@material-ui/core/Box";

function Instructions() {
  return (
    <Box p={1}>
      <p className="App-p">
        Varaa puolen tunnin itsenäisiä treeniaikoja enintään neljä/viikko.
        Primetime ajalle arkisin klo 17-21 saa varata vain kaksi/viikko.
      </p>
      <p className="App-p">
        Varausta ei voi tehdä kuluvalle päivälle.
        Varauksia voi tehdä korkeintaan kaksi viikkoa eteenpäin.
        Tulevan varauksen voi poistaa "Omat varaukset"-välilehdellä.
      </p>
    </Box>
  );
}

export default Instructions;
